<template>
  <div>
    <!-- Desktop View -->
    <div class="hidden md:flex justify-end mb-4">
      <USelect
        v-model="selectedSort"
        :options="sortOptions"
        placeholder="Sıralama"
        class="w-48"
        @change="$emit('update:sort', selectedSort)"
      />
    </div>

    <!-- Mobile View -->
    <div class="md:hidden grid grid-cols-2 gap-2">
      <UButton
        class="col-span-1"
        variant="outline"
        color="gray"
        @click="$emit('show-filters')"
      >
        <template #leading>
          <UIcon name="i-heroicons-funnel" />
        </template>
        Filtrele
      </UButton>
      <UButton
        class="col-span-1"
        variant="outline"
        color="gray"
        @click="showSortModal = true"
      >
        <template #leading>
          <UIcon name="i-heroicons-arrows-up-down" />
        </template>
        Sırala
      </UButton>
    </div>

    <!-- Mobile Sort Modal -->
    <UModal v-model="showSortModal">
      <UCard :ui="{ ring: '', divide: 'divide-y divide-gray-100' }">
        <template #header>
          <div class="flex items-center justify-between">
            <h3 class="text-base font-semibold leading-6 text-gray-900">
              Sıralama
            </h3>
            <UButton
              color="gray"
              variant="ghost"
              icon="i-heroicons-x-mark-20-solid"
              class="-my-1"
              @click="showSortModal = false"
            />
          </div>
        </template>
        <div class="space-y-2 py-2">
          <URadio
            v-for="option in sortOptions"
            :key="option.value"
            v-model="selectedSort"
            :value="option.value"
            :label="option.label"
            @change="updateSort"
          />
        </div>
      </UCard>
    </UModal>
  </div>
</template>

<script setup>
const props = defineProps({
  modelValue: {
    type: String,
    default: null
  }
})

const emit = defineEmits(['update:sort', 'show-filters'])

const selectedSort = ref(props.modelValue)
const showSortModal = ref(false)
const showFilters = ref(false)

const sortOptions = [
  { label: 'Önerilen', value: 'best_selling' },
  { label: 'En Yeniler', value: 'newest' },
  { label: 'Fiyat: Düşükten Yükseğe', value: 'price_asc' },
  { label: 'Fiyat: Yüksekten Düşüğe', value: 'price_desc' },
  { label: 'En Çok Satanlar', value: 'best_selling' }
]

const updateSort = () => {
  emit('update:sort', selectedSort.value)
  showSortModal.value = false
}

watch(
  () => props.modelValue,
  (newValue) => {
    selectedSort.value = newValue
  }
)
</script>
